import { render, staticRenderFns } from "./DashboardApplication.vue?vue&type=template&id=2b8ca58e&"
import script from "./DashboardApplication.vue?vue&type=script&lang=js&"
export * from "./DashboardApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports